var default_styles_default = {
  "button_container": "uIMas",
  "button_margin": "H1aBT",
  "button_text": "xXN41",
  "button_size_content": "h7Drq"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
